<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div
    class="relative overflow-hidden rounded-3 border-1px border-light bg-gradient-to-br from-#FFFBF1 to-white shadow-dark hover:shadow-dark duration-200 p-4 md:p-8">
    <img
      src="https://lp-file.lifepage.cc/operation/20260511180409038_XwGl4tWJrk.png"
      class="absolute right-0 top-0 w-24 md:w-36 pointer-events-none select-none opacity-60" />
    <div class="relative z-10">
      <div class="text-xl font-bold text-main leading-6">
        {{ t('m.public_figure_intro_title') }}
      </div>
      <div class="mt-4 md:mt-6 text-sm text-second leading-6">
        <div>{{ t('m.public_figure_intro_p1') }}{{ t('m.public_figure_intro_p') }}</div>
      </div>
    </div>
  </div>
</template>
